'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _SheetOverlay, _SheetPrimitive$Close;
var _excluded = ["className"],
  _excluded2 = ["side", "className", "children"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
import * as React from 'react';
import * as SheetPrimitive from '@radix-ui/react-dialog';
import { cva } from 'class-variance-authority';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { cn } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var SheetPortal = SheetPrimitive.Portal;
var SheetOverlay = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SheetPrimitive.Overlay, _objectSpread(_objectSpread({
    className: cn('tw-fixed tw-inset-0 tw-z-7 tw-bg-neutral-light-800 tw-opacity-50 tw-backdrop-blur-sm data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0', className)
  }, props), {}, {
    ref: ref
  }));
});
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
var sheetVariants = /*#__PURE__*/cva('tw-fixed tw-z-dialog tw-gap-4 tw-bg-neutral-light-100 tw-p-1.6 tw-shadow-04 tw-transition tw-ease-in-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-duration-500 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out dark:tw-bg-neutral-dark-700', {
  variants: {
    side: {
      top: 'tw-inset-x-0 tw-top-0 tw-border-b data-[state=closed]:tw-slide-out-to-top data-[state=open]:tw-slide-in-from-top',
      bottom: 'tw-inset-x-0 tw-bottom-0 tw-border-t data-[state=closed]:tw-slide-out-to-bottom data-[state=open]:tw-slide-in-from-bottom',
      left: 'tw-inset-y-0 tw-left-0 tw-h-full tw-w-3/4 tw-border-r data-[state=closed]:tw-slide-out-to-left data-[state=open]:tw-slide-in-from-left sm:tw-max-w-sm',
      right: 'tw-inset-y-0 tw-right-0 tw-h-full tw-w-3/4 tw-border-l data-[state=closed]:tw-slide-out-to-right data-[state=open]:tw-slide-in-from-right sm:tw-max-w-sm'
    }
  },
  defaultVariants: {
    side: 'right'
  }
});
var SheetContent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$side = _ref2.side,
    side = _ref2$side === void 0 ? 'right' : _ref2$side,
    className = _ref2.className,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(SheetPortal, {
    children: [_SheetOverlay || (_SheetOverlay = /*#__PURE__*/_jsx(SheetOverlay, {})), /*#__PURE__*/_jsxs(SheetPrimitive.Content, _objectSpread(_objectSpread({
      ref: ref,
      className: cn(sheetVariants({
        side: side
      }), className)
    }, props), {}, {
      children: [_SheetPrimitive$Close || (_SheetPrimitive$Close = /*#__PURE__*/_jsxs(SheetPrimitive.Close, {
        className: "tw-absolute tw-right-1.2 tw-top-1.2 tw-rounded-1 tw-opacity-70 tw-ring-offset-neutral-light-100 tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none disabled:tw-pointer-events-none data-[state=open]:tw-bg-neutral-light-300 dark:tw-ring-offset-neutral-light-700 dark:focus:tw-ring-neutral-light-600 dark:data-[state=open]:tw-bg-neutral-light-700 tw-text-neutral-light-800 dark:tw-text-neutral-dark-400",
        children: [/*#__PURE__*/_jsx(CloseSmall, {
          className: "tw-fill-current",
          size: 24
        }), /*#__PURE__*/_jsx("span", {
          className: "tw-sr-only",
          children: "Close"
        })]
      })), children]
    }))]
  });
});
SheetContent.displayName = SheetPrimitive.Content.displayName;
var SheetHeader = function SheetHeader(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-flex tw-flex-col tw-space-y-2 tw-text-center sm:tw-text-left', className)
  }, props));
};
SheetHeader.displayName = 'SheetHeader';
var SheetFooter = function SheetFooter(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-flex tw-flex-col-reverse sm:tw-flex-row sm:tw-justify-end sm:tw-space-x-2', className)
  }, props));
};
SheetFooter.displayName = 'SheetFooter';
var SheetTitle = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx(SheetPrimitive.Title, _objectSpread({
    ref: ref,
    className: cn('tw-font-subtitle3 tw-text-neutral-light-800 dark:tw-text-neutral-dark-100', className)
  }, props));
});
SheetTitle.displayName = SheetPrimitive.Title.displayName;
var SheetDescription = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsx(SheetPrimitive.Description, _objectSpread({
    ref: ref,
    className: cn('tw-font-body4 tw-text-neutral-light-800 dark:tw-text-neutral-dark-100', className)
  }, props));
});
SheetDescription.displayName = SheetPrimitive.Description.displayName;
export { Sheet, SheetPortal, SheetOverlay, SheetTrigger, SheetClose, SheetContent, SheetHeader, SheetFooter, SheetTitle, SheetDescription };